import React from 'react';
import { useNavigate } from 'react-router-dom';
import { routeNames } from '../../../routes/routeNames';
import { FaExternalLinkAlt } from 'react-icons/fa';
import ContactButton from '../ContactButton';

const CallToActionSection = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-br from-darkBackground to-primary text-white text-center p-6 py-10 flex flex-col lg:flex-row justify-between items-center space-y-6 lg:space-y-0 lg:space-x-10">
      {/* Heading */}
      <div className="flex-1">
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold">
          Eliminate Pain And Improve Health & Wellness Today
        </h1>
      </div>

      {/* Contact Button */}
      <div className="w-full lg:w-auto">
        <ContactButton 
          bookOnlinestyle={"bg-orange text-white py-4 px-8 rounded-full font-semibold text-center"} 
          callButtonStyle={"text-white py-4 px-8 rounded-full font-semibold text-center"} 
        />
      </div>
    </div>
  );
};

export default CallToActionSection;